// extracted by mini-css-extract-plugin
export default {"process-output":"ProcessOutput_process-output__eKPap","detail-output":"ProcessOutput_detail-output__Jhw8T"};